import React from "react";

import { SortingSelector } from "../SortingSelector";

import styles from "./index.module.scss";

export const TopBar = (): React.ReactNode => {
    return (
        <div className={styles.topFilters}>
            <div className={styles.itemContainer}></div>
            <SortingSelector />
        </div>
    );
};
